import React, { useState } from "react";
import Select, { createFilter } from "react-select";
import PhoneInput, {
  getCountryCallingCode,
  parsePhoneNumber,
} from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";

const filterCountries = createFilter({
  matchFrom: "start",
  stringify: (option) => option.label,
});

const CountrySelect = ({
  value,
  onChange,
  options,
  disabled,
  readOnly,
  onFocus,
  onBlur,
  "aria-label": ariaLabel,
}) => {
  const countries = options
    .filter((option) => !option.divider)
    .map((option) => ({
      ...option,
      label: option.value
        ? `${option.label} (+${getCountryCallingCode(option.value)})`
        : option.label,
    }));

  return (
    <Select
      inputId="phone-country"
      className="international-phone-country"
      classNamePrefix="phone-country"
      aria-label={ariaLabel}
      value={countries.find((option) => option.value === value)}
      options={countries}
      filterOption={filterCountries}
      formatOptionLabel={(option, { context }) =>
        context === "value" && option.value
          ? `${option.value} +${getCountryCallingCode(option.value)}`
          : option.label
      }
      onChange={(option) => onChange(option.value)}
      onFocus={onFocus}
      onBlur={onBlur}
      isDisabled={disabled || readOnly}
      isClearable={false}
      isSearchable
      noOptionsMessage={() => "No se encontraron países"}
      placeholder="Selecciona un país"
    />
  );
};

const InternationalPhoneInput = ({
  invalid,
  placeholder = "Número de teléfono",
  onCountryChange,
  ...props
}) => {
  const [country, setCountry] = useState(
    () => parsePhoneNumber(props.value || "")?.country || "VE"
  );

  return (
    <PhoneInput
      {...props}
      className={`international-phone-input${invalid ? " international-phone-input--invalid" : ""}`}
      defaultCountry="VE"
      initialValueFormat="national"
      addInternationalOption={false}
      labels={es}
      placeholder={country === "VE" ? "(0414) 123-4567" : placeholder}
      onCountryChange={(value) => {
        setCountry(value);
        onCountryChange?.(value);
      }}
      countryCallingCodeEditable={false}
      countrySelectComponent={CountrySelect}
      countrySelectProps={{ "aria-label": "País y código telefónico" }}
      numberInputProps={{
        className: "form-control",
        "aria-invalid": Boolean(invalid),
      }}
    />
  );
};

export default InternationalPhoneInput;
